import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import D from '../images/user.png'
import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import apiService from '../api/ApiService';
import { TicketList } from '../redux/slices/adminSlice';
import { toast } from 'react-toastify';
import { Close } from '@mui/icons-material';
const moment=require('moment-jalaali');


const TicketNEw=({data,flag})=>{
    const [response,setResponse]=useState('')
    const {currentAdmin,tickets}=useSelector(state=>state.p.admin)
    const [show,setShow]=useState(false)
    const {openDeleteModal,closedeleteModal,isDeleteModalOpen}=useGlobalContext();
    const {createAt}=data;
    const pbirth=moment(createAt).format('jYYYY-jMM-jDD HH:mm')
    const dispatch=useDispatch();
    const navigate=useNavigate()
    const handleToggle=async()=>{
        if(flag==1){
            const res=await apiService.toggleTicket(data?.id);
            const filtered=tickets.filter((item)=>{
                return  item?.id!==data?.id
            })
            dispatch(TicketList(filtered))
        }

    }
    const responseTickett=async()=>{
        if(response&&response.length<2000){
            const data1=JSON.stringify({
                "answer": response
              })
            const res=await apiService.responseTicket(data?.id,data1)
            const filtered=tickets.filter((item)=>{
                return  item?.id!==data?.id
            })
            dispatch(TicketList(filtered))
            openDeleteModal();
            toast.success('عملیات با موفقیت انجام شد')
        }else if(response.length<2000){
            toast.error('تعداد کاراکتر ها باید کمتر از 2000 باشد')
        }else{
            toast.error('مقداری را وارد کنید')
        }
    }
   useEffect(()=>{
    handleToggle()
   },[])
    

    return <div onClick={closedeleteModal} className={`modal-overlay ${isDeleteModalOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" style={{position:'relative'}} >
        <div className="closee"><Close className='closee'/></div>
        {/* <div className="editModalDamConHead absoluteLetterIcon" >
        <MarkEmailReadIcon style={{width:'90px',height:'90px'}}/>
        </div> */}

            <div className="editModalDamConHead">
                <div className="TitlesHeadMess">
                    <article>
                    <img src={D}/>
                    <div>
                        <p>{currentAdmin?.ownerName}</p>
                        <h6>{currentAdmin?.name}</h6>
                    </div>
                    </article>
                    <p>{pbirth}</p>
                </div>
                
            </div>
            
            <p className="editModalDamConHead"><h4 >عنوان: </h4>  {data&&data?.title}</p>
            <p className="editModalDamConHeadDes">{data&&data?.question}</p>
        {!data?.answer?!show&&<button className="EditMOdalBtnForm" onClick={()=>setShow(!show)}>
            پاسخ
        </button>:<div style={{backgroundColor:'#e5ede5',padding:'10px',borderRadius:'10px',width:'100%',flexDirection:'column'}} className="editModalDamConHead"><h4 style={{borderRadius:'10px',width:'100%'}}>پاسخ ادمین: </h4>  <p style={{color:'black',fontSize:'12px'}}>{data?.answer}</p></div>}
        {!data?.answer&&show&&<div style={{width:'100%'}}>
            <textarea onChange={(e)=>{setResponse(e.target.value)}} className='ResponseTextArea' defaultValue={response} placeholder='پاسخ خود را وارد کنید'></textarea>
            <div className='POpOpBTnsConss'>
            <button className="EditMOdalBtnForm" onClick={responseTickett}>
            تایید
        </button>
        <button className="EditMOdalBtnForm" onClick={()=>setShow(!show)}>
            انصراف
        </button>
            </div>
        </div>
        
        }
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
    </div>
}
export default TicketNEw